/**
 * Created by Ning Jiang on 2021-06-30.
 */

import {TombstoneRipNormalResultPresentation} from "./TombstoneRipNormalResultPresentation";
import {TombstoneRip} from "../TombstoneRip";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {TombstoneRipReelController} from "../reels/TombstoneRipReelController";

export class TombstoneRipSuperFsResultPresentation extends TombstoneRipNormalResultPresentation {

    protected _reelStopOrder:number[] = [4, 0, 1, 2, 3]; // reelId[]
    protected _reelNormalStopDelay:number[] = [1.5, 1, 1, 1, 2];
    protected _reelFastStopDelay:number[] = [1, 0.5, 0.5, 0.5, 1];

    private _flowStateController:FlowStateController;
    private _normalStopping:boolean;

    constructor() {
        super();
    }

    public async start(flowStateController:FlowStateController):Promise<void> {
        this._flowStateController = flowStateController;
        flowStateController.setSkipCallback(() => this.skip());
        TombstoneRip.reelStopPresentations.start().then(res => {
            this.testSymbolPositions();
            flowStateController.finish();
        });

        if(!this._defaultSpinDuration) {
            // This simple calculation doesn't cover strange stopping order.
            this._defaultSpinDuration = ArrayHelper.arraySum(this._reelNormalStopDelay) + TombstoneRip.reels[4].getDefaultStoppingTime();
        }

        this._normalStopping = false;
        await TombstoneRip.superFsPop.show(true, true, false);

        TombstoneRip.reel5Frame.startSuperSpin();
        if(TombstoneRip.model.parsedGameData.superFSInfo.outlawMultiplierValue >= 310) {
            TombstoneRip.nearWin.playSFSReel5NearWin();
        }
        this._normalStopping = true;
        this._flowStateController.setSkipCallback(() => this.skip());
        this.getReelsStopResult(false, 0.01);
    }

    protected skip():void {
        // Logger.logDev("skip result");
        if(TombstoneRip.superFsPop.skip()) {
            this._flowStateController.setSkipCallback(() => this.skip());
            return;
        }

        if(this._normalStopping) {
            super.skip();
            this._normalStopping = false;
        }
    }

    protected getReelStopDelay(reel:TombstoneRipReelController, quickStop:boolean):number {
        if(reel.reelId === 3 && TombstoneRip.model.parsedGameData.singleWin === 0) {
            return 0.2;
        }

        return super.getReelStopDelay(reel, quickStop);
    }
}